import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { BlockedScoreTooltip } from 'src/components/BlockedScoreTooltip';
import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import Score from 'src/components/Score';
import { BLOCKED_REASON } from 'src/data/common';
import { COLOR_DARK_GRAY, COLORS } from 'src/data/ui';

import ScoreLoader from './ScoreLoader';

const useStyles = makeStyles(
  () => ({
    tooltip: {
      backgroundColor: COLORS.neutral.white,
    },
    darkTooltip: {
      backgroundColor: COLOR_DARK_GRAY,
    },
    limitedTooltipText: {
      color: COLORS.neutral.white,
      '& span': {
        color: COLORS.success.default,
      },
    },
    icon: {},
  }),
  { name: 'ScoreView' }
);

export const ScoreView = ({
  className,
  score,
  updating,
  onHover,
  blockedReason,
  generationTool,
  isLoading,
  grayScaleLoader,
  ...props
}) => {
  const styles = useStyles();

  const isLimitedScoring = blockedReason === BLOCKED_REASON.limitedScoring;
  const generationToolIcon = generationTool && (
    <GenerationToolIcon
      className={styles.icon}
      tool={generationTool}
    />
  );

  return (
    <div
      className={className}
      data-testid="ScoreView"
    >
      {updating ? (
        <ScoreLoader />
      ) : (
        <BlockedScoreTooltip
          className={isLimitedScoring ? styles.darkTooltip : styles.tooltip}
          nonBlockedTitle={
            isLimitedScoring ? (
              <Typography className={styles.limitedTooltipText}>
                <span>Upgrade</span> your subscription to unlock
                <br />
                real-time scoring and analytics for every copy edit you make.
              </Typography>
            ) : (
              ''
            )
          }
        >
          <Score
            locked={!!blockedReason}
            score={score}
            onMouseOver={!blockedReason ? onHover : null}
            onFocus={onHover}
            generationToolIcon={generationToolIcon}
            {...props}
            loading={isLoading}
            grayScaleLoader={grayScaleLoader}
          />
        </BlockedScoreTooltip>
      )}
    </div>
  );
};

ScoreView.propTypes = {
  className: PropTypes.string,
  score: PropTypes.number,
  updating: PropTypes.bool,
  onHover: PropTypes.func,
  blockedReason: PropTypes.oneOf(Object.values(BLOCKED_REASON)),
  generationTool: PropTypes.string,
  isLoading: PropTypes.bool,
  grayScaleLoader: PropTypes.bool,
};

ScoreView.defaultProps = {
  className: null,
  score: null,
  updating: false,
  onHover: null,
  blockedReason: null,
  generationTool: null,
  isLoading: false,
  grayScaleLoader: false,
};
